export enum OrganisationRouteNames {
    CUSTOMER_ONBOARDING = "CustomerOnboarding",
    COMPLIANCE = "Compliance",
    COMPANY_DETAILS = "CompanyDetailsCompliance",
    NATURE_OF_BUSINESS = "NatureOfBusiness",
    FINANCIAL_SYSTEM = "FinancialSystem",
    GOVERNANCE = "Governance",
    BANK_ACCOUNT_INFORMATION = "BankAccountInformation",
    SETTINGS = "Settings",
    ACCOUNT_INFORMATION = "AccountInformation",
    CONTACT_DETAILS = "ContactDetails",
    POSTING_SETTINGS = "PostingSettings",
    API_KEYS = "ApiKeys",
    PAYMENT_SETTINGS = "PaymentSettings",
    E_MANDATES_SETTINGS = "EMandatesSettings",
    USER_MANAGEMENT = "UserManagement",
    IDENTITY_PROVIDER = "IdentityProvider",
    RECONCILIATION = "Reconciliation",
    RECONCILIATION_MATCHES = "ReconciliationMatches",
    RECONCILIATION_POSTING_REPORT = "ReconciliationPostingReport",
    RECONCILIATION_UNMATCHED_TRANSACTIONS = "ReconciliationUnmatchedTransactions",
    FINANCIAL_AND_BILLING_SYSTEMS_INTEGRATION = "FinancialAndBillingSystemsIntegration",
    TRANSACTIONS_UNRECOGNISED_PAYMENTS = "TransactionsUnrecognisedPayments",
    BACS_ACCOUNTS_MANAGEMENT = "BacsAccountsManagement",
    BACS = "BACS",
    BACS_BATCHES = "Batches",
    BACS_BATCH = "Batch",
    BACS_DOWNLOAD_FILE = "DownloadFile",
    BACS_REPORTS = "Reports",
    BACS_REPORT_EVENTS = "Events",
    ALL_MANDATES = "AllMandates",
    USERS = "Users",
    CARD_PROVIDER_ONBOARDING = "CardProviderOnboarding",
    DASHBOARD = "SchoolOverview",
    CARD_STATEMENTS = "CardStatements",
    CARD_STATEMENT_DETAILS = "CardStatementDetails",
    NOTIFICATION_SETTINGS = "NotificationSettings",
    CARD_PAYOUTS = "CardPayouts",
    CARD_PAYOUT_DETAILS = "CardPayoutDetails",
    CONTRACTS = "Contracts",
}

export enum AuthRouteNames {
    LOGIN = "StandardLogin",
    SSO_LOGIN = "SsoLogin",
    SSO_SIGN_IN_REDIRECT = "SsoSignInRedirect",
    SSO_SIGN_OUT_REDIRECT = "SsoSignOutRedirect",
    UNAUTHORISED_ACCESS = "UnauthorisedAccess",
    NOT_FOUND = "404",
}

export const ORGANISATION_QUERY_PARAM = "organisation";
